import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import IconMobileGrid3x from 'components/icons/iconMobileGrid3x';
import MobileFiltersButton from 'components/consumer/MobileFiltersButton';
import ExpandableModalOptions from 'components/consumer/ExpandableModalOptions';
import ShopByMobileFiltersBar from 'components/consumer/ShopByMobileFiltersBar';
import PropTypes from 'prop-types';
import getTabId from 'commons/getTabId';
import cx from 'classnames';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import ColorFilters from './ColorFilters';
import DesktopTierFilters from './DesktopTierFilters';
import FeaturesFilters from './FeaturesFilters';
const FabricPageHeader = props => {
  const $ = _c(76);
  const {
    selectedMaterialType,
    selectedColors,
    selectedFeatures,
    selectedTiers,
    selectedFabric,
    fabricColors,
    fabricTiers,
    sortBy,
    sortByOptions,
    showFavorites,
    numberOfActiveFilters,
    showColorFilters,
    showFeaturesFilters,
    showTierFilters,
    isMobileSortByOpen,
    mobileItemsPerRow,
    mobileButtonItems,
    bannerHeight,
    setSortBy,
    toggleSelectedColor,
    toggleSelectedFeature,
    toggleSelectedTier,
    toggleMobileSortByOpen,
    toggleMobileItemsPerRow,
    toggleMobileFiltersOpen
  } = props;
  const t0 = bannerHeight !== 0;
  const t1 = bannerHeight === 0;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = cx("md:hidden sticky z-10 bg-white transition-[transform_.2s_ease-in-out]", {
      "top-0": t0,
      "top-[60px]": t1
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selectedMaterialType) {
    t3 = getTabId(selectedMaterialType, "FabricsPage");
    $[3] = selectedMaterialType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== mobileButtonItems || $[6] !== t3) {
    t4 = <ToggleTabGroup aria-label="Upholstery" items={mobileButtonItems} selectedTab={t3} />;
    $[5] = mobileButtonItems;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isMobileSortByOpen || $[9] !== mobileItemsPerRow || $[10] !== numberOfActiveFilters || $[11] !== selectedMaterialType || $[12] !== sortBy || $[13] !== sortByOptions || $[14] !== toggleMobileFiltersOpen || $[15] !== toggleMobileItemsPerRow || $[16] !== toggleMobileSortByOpen) {
    t5 = selectedMaterialType === "Fabric" && <ShopByMobileFiltersBar><MobileFiltersButton onClick={() => toggleMobileFiltersOpen()} numberOfActiveFilters={numberOfActiveFilters} /><span className={cx("text-sm font-bold items-center bg-white border border-solid rounded-sm text-gray flex justify-center p-3 cursor-pointer", {
        "border-gray-light6": !isMobileSortByOpen,
        "border-brand": isMobileSortByOpen
      })} role="presentation" onClick={() => toggleMobileSortByOpen(!isMobileSortByOpen)}><span className="h-full">{`Sort by ${sortByOptions.find(sortByOption => sortByOption.value === sortBy).label}`}</span></span><span className="items-center flex flex-1 justify-end"><span className="bg-none items-center bg-white border-0 flex justify-center ml-[3px] focus-visible:outline-offset-4" role="presentation" onClick={() => toggleMobileItemsPerRow()}>{mobileItemsPerRow === 1 ? <IconMobileGrid1x /> : mobileItemsPerRow === 2 ? <IconMobileGrid2x /> : <IconMobileGrid3x />}</span></span></ShopByMobileFiltersBar>;
    $[8] = isMobileSortByOpen;
    $[9] = mobileItemsPerRow;
    $[10] = numberOfActiveFilters;
    $[11] = selectedMaterialType;
    $[12] = sortBy;
    $[13] = sortByOptions;
    $[14] = toggleMobileFiltersOpen;
    $[15] = toggleMobileItemsPerRow;
    $[16] = toggleMobileSortByOpen;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const t6 = isMobileSortByOpen && selectedMaterialType === "Fabric";
  let t7;
  if ($[18] !== toggleMobileSortByOpen) {
    t7 = () => toggleMobileSortByOpen(false);
    $[18] = toggleMobileSortByOpen;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== setSortBy || $[21] !== sortBy || $[22] !== sortByOptions || $[23] !== toggleMobileSortByOpen) {
    let t9;
    if ($[25] !== setSortBy || $[26] !== sortBy || $[27] !== toggleMobileSortByOpen) {
      t9 = t10 => {
        const {
          label,
          value
        } = t10;
        return {
          label,
          id: label,
          isSelected: sortBy === value,
          onClick: () => {
            toggleMobileSortByOpen(false);
            setSortBy(value);
          }
        };
      };
      $[25] = setSortBy;
      $[26] = sortBy;
      $[27] = toggleMobileSortByOpen;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    t8 = sortByOptions.map(t9);
    $[20] = setSortBy;
    $[21] = sortBy;
    $[22] = sortByOptions;
    $[23] = toggleMobileSortByOpen;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t9 = <div className="relative max-[767px]:bg-white"><ExpandableModalOptions isOpen={t6} onClose={t7} label="Sort By" options={t8} /></div>;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t2 || $[34] !== t4 || $[35] !== t5 || $[36] !== t9) {
    t10 = <MobileOnly><div className={t2}>{t4}{t5}{t9}</div></MobileOnly>;
    $[33] = t2;
    $[34] = t4;
    $[35] = t5;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== mobileButtonItems) {
    t11 = mobileButtonItems.map(_temp);
    $[38] = mobileButtonItems;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  const t12 = showFavorites ? "Favorites" : selectedMaterialType;
  let t13;
  if ($[40] !== t11 || $[41] !== t12) {
    t13 = <ShopByHeaderSection label="Show Me"><ToggleButtonGroup aria-label="fabric filters" items={t11} selectedItem={t12} className="MaterialListToggleGroup" /></ShopByHeaderSection>;
    $[40] = t11;
    $[41] = t12;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== selectedMaterialType || $[44] !== setSortBy || $[45] !== sortBy || $[46] !== sortByOptions) {
    t14 = selectedMaterialType === "Fabric" && <ShopByHeaderSection label="Sort By"><ToggleButtonGroup aria-label="fabrics sortby" items={sortByOptions.map(t15 => {
        const {
          label: label_1,
          value: value_0
        } = t15;
        return {
          label: label_1,
          id: value_0,
          contentId: value_0,
          onClick: () => {
            setSortBy(value_0);
          }
        };
      })} selectedItem={sortBy} /></ShopByHeaderSection>;
    $[43] = selectedMaterialType;
    $[44] = setSortBy;
    $[45] = sortBy;
    $[46] = sortByOptions;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== fabricColors || $[49] !== selectedColors || $[50] !== selectedFabric || $[51] !== selectedMaterialType || $[52] !== showColorFilters || $[53] !== toggleSelectedColor) {
    t15 = selectedMaterialType === "Fabric" && showColorFilters && <ColorFilters fabricColors={fabricColors} toggleSelectedColor={c => toggleSelectedColor(c)} selectedColors={selectedColors} selectedFabric={selectedFabric} />;
    $[48] = fabricColors;
    $[49] = selectedColors;
    $[50] = selectedFabric;
    $[51] = selectedMaterialType;
    $[52] = showColorFilters;
    $[53] = toggleSelectedColor;
    $[54] = t15;
  } else {
    t15 = $[54];
  }
  let t16;
  if ($[55] !== selectedFabric || $[56] !== selectedFeatures || $[57] !== selectedMaterialType || $[58] !== showFeaturesFilters || $[59] !== toggleSelectedFeature) {
    t16 = selectedMaterialType === "Fabric" && showFeaturesFilters && <FeaturesFilters toggleSelectedFeature={v => toggleSelectedFeature(v)} selectedFeatures={selectedFeatures} selectedFabric={selectedFabric} />;
    $[55] = selectedFabric;
    $[56] = selectedFeatures;
    $[57] = selectedMaterialType;
    $[58] = showFeaturesFilters;
    $[59] = toggleSelectedFeature;
    $[60] = t16;
  } else {
    t16 = $[60];
  }
  let t17;
  if ($[61] !== fabricTiers || $[62] !== selectedMaterialType || $[63] !== selectedTiers || $[64] !== showTierFilters || $[65] !== toggleSelectedTier) {
    t17 = selectedMaterialType === "Fabric" && showTierFilters && <DesktopTierFilters fabricTiers={fabricTiers} toggleSelectedTier={v_0 => toggleSelectedTier(v_0)} selectedTiers={selectedTiers} />;
    $[61] = fabricTiers;
    $[62] = selectedMaterialType;
    $[63] = selectedTiers;
    $[64] = showTierFilters;
    $[65] = toggleSelectedTier;
    $[66] = t17;
  } else {
    t17 = $[66];
  }
  let t18;
  if ($[67] !== t13 || $[68] !== t14 || $[69] !== t15 || $[70] !== t16 || $[71] !== t17) {
    t18 = <TabletAndDesktopOnly><div className="max-[767px]:hidden pl-[3.333vw] pr-[3.333vw] [border-bottom:1px_solid_#f1f1f1] sticky top-[110px] z-[1000] bg-white [transition:transform_.2s_ease-in-out] max-[767px]:[border-bottom:1px_solid_#f1f1f1]"><div className="flex-wrap pt-6 px-0 pb-0 md:items-start md:flex md:min-h-[100px] md:mt-0 md:mb-0">{t13}{t14}{t15}{t16}{t17}</div></div></TabletAndDesktopOnly>;
    $[67] = t13;
    $[68] = t14;
    $[69] = t15;
    $[70] = t16;
    $[71] = t17;
    $[72] = t18;
  } else {
    t18 = $[72];
  }
  let t19;
  if ($[73] !== t10 || $[74] !== t18) {
    t19 = <>{t10}{t18}</>;
    $[73] = t10;
    $[74] = t18;
    $[75] = t19;
  } else {
    t19 = $[75];
  }
  return t19;
};
FabricPageHeader.propTypes = {
  // Filter/Data props
  selectedMaterialType: PropTypes.string,
  selectedColors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedFeatures: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedTiers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedFabric: PropTypes.object,
  fabricColors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  fabricTiers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  sortBy: PropTypes.string,
  sortByOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  showFavorites: PropTypes.bool,
  numberOfActiveFilters: PropTypes.number,
  showColorFilters: PropTypes.bool,
  showFeaturesFilters: PropTypes.bool,
  showTierFilters: PropTypes.bool,
  // UI State props
  isMobileSortByOpen: PropTypes.bool,
  mobileItemsPerRow: PropTypes.number,
  mobileButtonItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    contentId: PropTypes.string,
    onClick: PropTypes.func
  })),
  bannerHeight: PropTypes.number,
  // Action props
  setSortBy: PropTypes.func,
  toggleSelectedColor: PropTypes.func,
  toggleSelectedFeature: PropTypes.func,
  toggleSelectedTier: PropTypes.func,
  toggleMobileSortByOpen: PropTypes.func,
  toggleMobileItemsPerRow: PropTypes.func,
  toggleMobileFiltersOpen: PropTypes.func
};
export default FabricPageHeader;
function _temp(t0) {
  const {
    label: label_0,
    contentId,
    onClick
  } = t0;
  return {
    label: label_0,
    id: contentId,
    contentId,
    onClick
  };
}